import type { APIOutputs, ChatMessage } from "@client/types";
import { defineStore } from "pinia";
import { PlayerData } from "@client/types";
import { ref } from "vue";
type Chats = Record<number, ChatMessage[]>;
export const useUserStore = defineStore("user", () => {
	const user = ref({} as APIOutputs["user"]["profile"]);

	const friendList = ref([] as APIOutputs["friends"]["list"]);
	const requests = ref<APIOutputs["friends"]["requests"]["all"]>({
		incoming: [],
		outgoing: [],
	});
	const activeChatId = ref(-1);
	const chats = reactive(JSON.parse(localStorage.getItem("chats") || "{}") as Chats);
	const pendingChatIds = ref<Set<number>>(
		new Set(JSON.parse(localStorage.getItem("pendingChatIds") || "[]")),
	);
	const hasIncomingRequests = computed(() => requests.value.incoming.length > 0);

	const isAuth = ref(false);
	const saveCredentials = (data: APIOutputs["auth"]["login"]): void => {
		const prevData = JSON.parse(
			localStorage?.getItem("data") || "{}",
		) as APIOutputs["auth"]["login"];
		if (prevData.id !== data.id) localStorage.clear();
		isAuth.value = true;
		user.value = data;

		localStorage.setItem("data", JSON.stringify(data)); //TODO: safe parsing of JSON
	};

	function getUserInfo(): PlayerData {
		return {
			id: user.value.id,
			username: user.value.username,
			avatarUrl: user.value.avatarUrl,
			medPoints: user.value.medPoints || 0,
			university: user.value.university,
		};
	}
	const clearCredentials = () => {
		isAuth.value = false;
		user.value = {} as any;
		localStorage.removeItem("data");
	};

	function setPendingChatId(id: number) {
		pendingChatIds.value.add(id);
		localStorage.setItem("pendingChatIds", JSON.stringify(Array.from(pendingChatIds.value)));
	}
	function removePendingChatId(id: number) {
		pendingChatIds.value.delete(id);
		localStorage.setItem("pendingChatIds", JSON.stringify(Array.from(pendingChatIds.value)));
	}
	return {
		user,
		isAuth,
		friendList,
		saveCredentials,
		clearCredentials,
		getUserInfo,
		hasIncomingRequests,
		requests,
		activeChatId,
		pendingChatIds,
		setPendingChatId,
		removePendingChatId,
		chats,
	};
});
